import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/loox-status")({
  component: lazyRouteComponent(() => import("./-pages/admin.loox-status")),
  head: () => ({
    meta: [
      { title: "حالة Loox · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
